
























































import { Component, Vue } from 'vue-property-decorator';

import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { Subscription } from '@/types/core-push';

import SectionHeader from '@/components/SectionHeader.vue';
import KeyValue from '@/components/KeyValue.vue';
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue'; 

import SnsEndpointView from '@/components/subscriptions/SnsEndpointView.vue';
import HttpEndpointView from '@/components/subscriptions/HttpEndpointView.vue';
import KinesisEndpointView from '@/components/subscriptions/KinesisEndpointView.vue';
import SubFilters from '@/components/subscriptions/SubFilters.vue';
import DeliveryList from '@/components/subscriptions/DeliveryList.vue';

import EnterpriseId from '@/components/EnterpriseId.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import AzureEventHubEndpointView from "@/components/subscriptions/AzureEventHubEndpointView.vue";
import MqttEndpointView from "@/components/subscriptions/MqttEndpointView.vue";

@Component({
  components: {
    MqttEndpointView,
    SectionHeader,
    KeyValue,
    VueError,
    Success,
    SnsEndpointView,
    HttpEndpointView,
    KinesisEndpointView,
    AzureEventHubEndpointView,
    EnterpriseId,
    SubFilters,
    TimestampAgo,
    DeliveryList
  },
})
export default class SingleSubscription extends Vue {

  sub:Subscription = {} as Subscription;
  
  errorMsg:string = '';

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  async mounted() {

    this.refresh();
  }

  async refresh() {

    let subId = parseInt(this.$route.params.subId);

    if(isNaN(subId))
      return this.$router.push({name:'subscriptions'});

    const reply = await this.coreClient.getSubscription({subId});

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.errorMsg = `Unable to retrieve subscription ${this.$route.params.subId}: ${reply.errorMsg}`;

    this.sub = reply.sub!;
  }

  get infoIconList():object[] {
    return [
      {name:'arrow-left', title:'back to sub list', event:'sub-list'}
    ];
  }

  goToSubList() {
    return this.$router.push({name:'subscriptions'});
  }
  
}
